import { List, fromJS } from 'immutable'

export function timezones(state = List([]), action) {
	switch(action.type) {
		case 'TIMEZONES_FETCH_DATA_SUCCESS':
			return fromJS(action.timezones)
		default:
			return state
	}
}